import React, {PureComponent} from "react"
import styled from "styled-components"
import PropTypes from "prop-types"

import {LocationMarker as DefaultLocationMarker} from "@irati-web/geolocation/src/components/GeoMap"
import {getOptimalInfoWindowProperties} from "@irati-web/geolocation/src/helpers/infoWindow"

import {greys} from "@irati/ui/src/global/colors"
import {DosisBold} from "@irati/ui/src/global/fonts"
import InfoWindow from "./InfoWindow"

const StyledMarker = styled(DefaultLocationMarker)`
  color: ${greys.white};
  font-size: 14px;
  ${DosisBold}
  display: flex;
  align-items: center;
  justify-content: center;
  position: relative;

  ${({isActive}) => isActive && `
    width: 40px;
    height: 40px;
    border: 3px solid ${greys.white};
  `}

  ${({zIndex}) => `
    z-index: ${zIndex};
  `}
`

const StyledInfoWindow = styled(InfoWindow)`
  position: absolute;
  top: 0;
  left: 0;
  ${({position}) => (position === "top") && `
    transform: translateX(calc(-50% + 10px)) translateY(calc(-100% - 30px));
  `}
  ${({position}) => (position === "right") && `
    transform: translateX(70px) translateY(calc(-50% + 10px));
  `}
  ${({position}) => (position === "bottom") && `
    transform: translateX(calc(-50% + 35px)) translateY(75px);
  `}
  ${({position}) => (position === "left") && `
    transform: translateX(calc(-100% - 30px)) translateY(calc(-50% + 30px));
  `}
  ${({zIndex}) => `
    z-index: ${zIndex + 1};
  `}
`

const Container = styled.div`
  position: relative;
`
class LocationMarker extends PureComponent {
  render() {
    const {index, number, deal, onClick, isActive, showDetails, zIndex, lat, lng, boundingBox, searchTerm} = this.props
    const {position, arrowPosition} = getOptimalInfoWindowProperties(boundingBox, {lat, lng})
    return (
      <Container>
        <StyledMarker isActive={isActive} zIndex={zIndex} onClick={() => { onClick(deal.location.uuid, index) }}>{number}</StyledMarker>
        {showDetails && (
          <StyledInfoWindow
            position={position}
            arrowPosition={arrowPosition}
            zIndex={zIndex}
            deal={deal}
            searchTerm={searchTerm} />
        )}
      </Container>
    )
  }
}

LocationMarker.propTypes = {
  index: PropTypes.number.isRequired,
  number: PropTypes.number.isRequired,
  deal: PropTypes.object.isRequired,
  onClick: PropTypes.func,
  isActive: PropTypes.bool,
  showDetails: PropTypes.bool,
  zIndex: PropTypes.number,
  boundingBox: PropTypes.array.isRequired,
  lat: PropTypes.number.isRequired,
  lng: PropTypes.number.isRequired,
  searchTerm: PropTypes.string
}

LocationMarker.defaultProps = {
  onClick: () => {},
  isActive: false,
  showDetails: false,
  zIndex: 1,
  searchTerm: ""
}

export default LocationMarker
